import { Box } from '@mui/material';
import { TimeFormats } from '@uplift/constants';
import { DateObject } from '@uplift/services';
import { useMemo } from 'react';
import { Button } from '../../Button';
import { useStyles } from '../styles';
import { OnSetSelectedSlotType, Timeslot } from '../types';
import { EmptySlots, EmptySlotsProps } from './empty-slots.component';
import clsx from 'clsx';

export type TriadTimeslotsProps = {
  slotsColumns: Timeslot[][];
  selectedSlot: DateObject | null;
  onSetSelectedSlot: OnSetSelectedSlotType;
} & EmptySlotsProps;

export const TriadTimeslots: React.VFC<TriadTimeslotsProps> = props => {
  const { classes } = useStyles();

  const isEmpty = useMemo(() => {
    return !props.slotsColumns.some((slots) => slots.length);
  }, [ props.slotsColumns ]);

  if (isEmpty) {
    return  (
      <Box className={clsx([ classes.timeSlotsRoot, classes.triadHeight ])}>
        <EmptySlots {...props} />
      </Box>
    );
  }

  return (
    <Box className={classes.triadSlotsRoot}>
      <Box className={classes.triadSlotsContainer}>
        {props.slotsColumns.map((slots, i) => {
          return (
            <Box key={i} display="flex" flexDirection="column" gap="0.5rem">
              {slots.map((slot) => {
                const isSelected = props.selectedSlot && props.selectedSlot.isSame(slot);

                return (
                  <Button
                    onClick={() => props.onSetSelectedSlot(slot)}
                    key={slot.toString()}
                    variant={isSelected ? 'contained' : 'outlined'}
                    color={isSelected ? 'secondary' : 'inherit'}
                    size="small"
                    fullWidth
                  >
                    {slot.format(TimeFormats['h:mm a'])}
                  </Button>
                );
              })}
            </Box>
          );
        })}
      </Box>
    </Box>
  );
};
